// extracted by mini-css-extract-plugin
export default {"floating-panel":"XKXPDSe1MqTzsdvfKb0G"};